import { HTTP } from '@miq/utiljs';

export const patchOrderItem = (itemSlug: string, values: { size: string; quantity: number }) => {
  return HTTP.post(`api/order/item/${itemSlug}/`, { ...values, redirect: true });
};

export const postOrderItem = (productSlug: string, values: { size: string; quantity: number }) => {
  return HTTP.post(`api/order/cart/${productSlug}/`, { ...values, redirect: true });
};
